import { ILiveIconProps } from "interfaces"

const LiveIcon = ({ isLive }: ILiveIconProps) => {
    return (
        <div className={`pl-w-4 pl-h-4 pl-rounded-full pl-flex pl-items-center pl-justify-center pl-border-2 pl-border-transparent border-l-2 pl-border-l-white pl-border-r-2 pl-border-r-white ${isLive && "pl-animate-ping"}`} style={{ animation: isLive ? "pl-ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite" : "" }}>
            <div className="pl-w-2 pl-h-2 pl-rounded-full pl-flex pl-items-center pl-justify-center pl-border-2 pl-border-transparent pl-border-l-2 pl-border-l-white pl-border-r-2 pl-border-r-white">
                <div className="pl-w-0.5 pl-h-0.5 pl-rounded-full pl-border pl-border-white"></div>
            </div>
        </div>
    )
}

export default LiveIcon